export const initialState = {
  isPending: false,
  isLoaded: false,
  isError: false,
  error: null, // normally only true or false
  entities: [],
}

export function createAPIRequestReducer(APIActionSequenceName) {
  return function APIRequestReducer(state = initialState, action) {
    switch (action.type) {
      case `${APIActionSequenceName}_DO_REQUEST`: {
        return {
          ...state,
          error: null,
          isError: false,
          isPending: true,
          isLoaded: false,
        }
      }

      case `${APIActionSequenceName}_SUCCESS`: {
        return {
          ...state,
          isPending: false,
          isLoaded: true,
          isError: false,
          error: null,
          entities: action.payload.result,
        }
      }

      case `${APIActionSequenceName}_FAILURE`:
        return {
          ...state,
          isPending: false,
          isLoaded: false,
          isError: true,
          error: {
            status: 403, // need to find a better status number
          },
        }

      case `${APIActionSequenceName}_RESET`:  
        return {
          ...state,
          isPending: false,
          isLoaded: false,
          isError: false,
          error: null,
        }

      default:
        return state
    }
  }
}

export const genericRequestState = {
  isPending: false,
  isFinished: false,
  isError: false,
}
/*
 * More generic version of the request reducer without assumptions of the request content
 */
export function createGenericRequestReducer(APIActionSequenceName) {
  return function GenericRequestReducer(state = genericRequestState, action) {
    switch (action.type) {
      case `${APIActionSequenceName}_REQUEST`:
        return {
          ...state,
          isError: false,
          isPending: true,
        }

      case `${APIActionSequenceName}_SUCCESS`: {
        return {
          isPending: false,
          isFinished: true,
          isError: false,
        }
      }

      case `${APIActionSequenceName}_FAILURE`:
        return {
          ...state,
          isPending: false,
          isError: true,
        }

      default:
        return state
    }
  }
}
